import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import TextField from '@mui/material/TextField'
import Input from '@mui/material/Input'
import React from 'react'
import { Formik } from 'formik'
import MaskedInput from 'react-text-mask'
import * as Yup from 'yup'
import * as S from './styles'
import { integrate } from '../RDIntegration'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props;

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				if (inputRef) {
					// Se inputRef for um objeto com a propriedade current (React.createRef())
					if (typeof inputRef === 'object' && 'current' in inputRef) {
						inputRef.current = ref ? ref.inputElement : null;
					}
					// Se inputRef for uma função
					else if (typeof inputRef === 'function') {
						inputRef(ref ? ref.inputElement : null);
					}
				}
			}}
			mask={['(',/\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			showMask
		/>
	);
}

const getContentText = (state, values, errors, handleChange) => {
	return (<Box>
		Para receber o resultado da simulação, preencha os campos abaixo:
		<TextField
			fullWidth variant="filled"
			id="name" name="name" type="text"
			onChange={handleChange}
			value={values.name} label="Nome"
			error={!!errors.name} helperText={errors.name || ' '}
		/>
		<TextField
			fullWidth variant="filled"
			id="email" name="email" type="email"
			onChange={handleChange}
			value={values.email} label="Email"
			error={!!errors.email} helperText={errors.email || ' '}
		/>
		<Input
			fullWidth variant="filled"
			id="phone" name="phone" type="text"
			inputComponent={TextMaskCustom}
			onChange={handleChange}
			value={values.phone} label="Telefone"
			error={!!errors.phone} helperText={errors.phone || ' '}
		/>
		<Box style={{marginTop: "12px"}}>
			Ao receber o resutado você está concordando com a nossa
			<Typography >
				<Box style={{ cursor: 'pointer', color: "#4e4ba6" }}
						 onClick={()=>{
							 window.open("https://monefica.com.br/politica-de-privacidade/", "_blank", "noreferrer");
						 }}
						 component={'span'}>
					política de privacidade
				</Box>
			</Typography>
		</Box>
	</Box>)
}
const getDialogAction = (
	state, setState, handleCloseDialog, data, handleSubmit, values) => {
	return (<DialogActions>
		<Button
			disabled={values.name === '' || values.email === '' || values.phone ===
				''}
			onClick={() => {
				handleSubmit()
				setState({ step: 2 })
			}} variant={'contained'} color="primary">
			RECEBER RESULTADO
		</Button>
		<Button onClick={() => {
			handleCloseDialog()
		}} variant={'contained'} color="secondary">
			VOLTAR
		</Button>
	</DialogActions>)
}

const DialogSchema = Yup.object().shape({
	name: Yup.string().
		required('Preencha este campo.').
		min(3, 'O nome deve ter pelo menos 3 letras.'),
	email: Yup.string().
		email('Email inválido.').
		required('Preencha este campo.'),
})

export function ConversionPaywallDialog ({
	state,
	setState,
	open,
	handleCloseDialog,
	data,
}) {

	return (<Formik
		validateOnBlur={false}
		validateOnChange={false}
		initialValues={{
			email: '',
			name: '',
			phone: '',
		}}
		validationSchema={DialogSchema}
		onSubmit={(values) => {
			if (process.env.NODE_ENV !== 'development') {
				integrate(data, {
					name: values.name,
					email: values.email,
					phone: values.phone,
				}).
					then(() => setState({
						index: 2,
						enable: 2,
					})).
					catch((e) => alert(
						'Ocorreu um erro, por favor recarregue a página e tente novamente.'))
			} else {
				handleCloseDialog()
				setState({
					index: 2,
					enable: 2,
				})
			}
		}}>
		{({
			values,
			errors,
			handleChange,
			handleSubmit,
			dirty,
			setFieldValue,
		}) => (<Dialog
			open={open}
			onClose={handleCloseDialog}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<S.Row>

						{getContentText(state, values, errors, handleChange)}
					</S.Row>
				</DialogContentText>
			</DialogContent>
			{getDialogAction(state, setState, handleCloseDialog, data, handleSubmit,
				values)}
		</Dialog>)}
	</Formik>)
}
